import { useKeyboardVisibility } from './useKeyboardVisibility';
import { useIsMobile } from './useIsMobile';

export interface FocusModeState {
  /** Whether the virtual keyboard is visible */
  isKeyboardVisible: boolean;
  /** Estimated keyboard height in pixels */
  keyboardHeight: number;
  /** Whether we're on mobile */
  isMobile: boolean;
}

/**
 * Hook to manage virtual keyboard handling and mobile detection.
 *
 * Note: Preview expand/collapse functionality has been removed.
 * Preview is now fixed at 52vh on mobile.
 *
 * @returns FocusModeState with keyboard visibility and mobile detection
 */
export function useFocusMode(): FocusModeState {
  const { isKeyboardVisible, keyboardHeight } = useKeyboardVisibility();
  const isMobile = useIsMobile();

  return {
    isKeyboardVisible,
    keyboardHeight,
    isMobile,
  };
}
